import { render, staticRenderFns } from "./DialogAddEditStats.vue?vue&type=template&id=756c4c47"
import script from "./DialogAddEditStats.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditStats.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports